/**
 * @file index.tsx
 *
 * @fileoverview InlineError component.
 */

import React from "react";
import styles from "./styles.module.scss";

export interface InlineErrorProps {
  /**
   * The message to be displayed in the error message.
   */
  message: string | React.ReactNode;
}

/**
 * A message that is shown bellow a input when the input has an error. This message is a way for the user to get immediate feedback on form items
 * that error for example on blur.
 */
export const InlineError = (props: InlineErrorProps) => {
  const { message } = props;
  return (
    <div
      className={styles.styledMessage}
      data-testid="alert"
      role="status"
      aria-live="polite"
    >
      {message}
    </div>
  );
};

export default InlineError;
